const URL = window.URL || window.webkitURL;

function getAudioDuration(url) {
  return new Promise((resolve, reject) => {
    try {
      const audio = document.createElement('audio');
      audio.addEventListener('loadedmetadata', () => {
        resolve(audio.duration);
      });
      audio.setAttribute('src', url);
    } catch (e) {
      reject(e);
    }
  });
}

function extractDurationWithFileReader(file) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = evt => {
        getAudioDuration(evt.target.result)
          .then(resolve)
          .catch(reject);
      };
      reader.readAsDataURL(file);
    } catch (e) {
      reject(e);
    }
  });
}

function extractDurationWithObjectURL(file) {
  return new Promise((resolve, reject) => {
    try {
      const objectURL = URL.createObjectURL(file);
      getAudioDuration(objectURL)
        .then(duration => {
          URL.revokeObjectURL(objectURL);
          resolve(duration);
        })
        .catch(reject);
    } catch (e) {
      reject(e);
    }
  });
}

export default file => {
  if (typeof URL === 'function' || typeof URL === 'object') {
    return extractDurationWithObjectURL(file);
  }
  if (typeof window.FileReader === 'function') {
    return extractDurationWithFileReader(file);
  }
  return Promise.reject(new Error('Not Supported'));
};
